module.exports = __webpack_public_path__ + "img/new_40.e7bc62a8.jpg";